import expand from "../../../assets/images/Expand.svg";
import Snapchat from "../../../assets/images/Snapchat.svg";
import Reddit from "../../../assets/images/Reddit.svg";
import Facebook from "../../../assets/images/Facebook.svg";
import Discord from "../../../assets/images/Discord.svg";
import Pinterest from "../../../assets/images/Pinterest.svg";
import TwitterX from "../../../assets/images/TwitterX.svg";
import LinkedIn from "../../../assets/images/LinkedIn.svg";
import Instagram from "../../../assets/images/Instagram.svg";
import YouTube from "../../../assets/images/YouTube.svg";
import WeChat from "../../../assets/images/WeChat.svg";
import Twitch from "../../../assets/images/Twitch.svg";
import WhatsApp from "../../../assets/images/WhatsApp.svg";
import TikTok from "../../../assets/images/TikTok.svg";
import Telegram from "../../../assets/images/Telegram App.svg";
import Website from "../../../assets/images/Website.svg";
import screenshare from "../../../assets/images/Screensharing.svg";
import Coin from "../../../assets/images/Stack of Coins.svg";
import Letter from "../../../assets/images/Email.svg";
import Bell from "../../../assets/images/Bell.svg";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SubscribeModal from "../subscribe";
import axios from "axios";
import { API_URL } from "../../../constants";
import { toast } from "react-toastify";
import {
  Container,
  Header,
  Description,
  ExpandIcon,
  Social,
  Finance,
  Col1,
  Pay,
  Email,
  Hello,
  Share,
  Subscribe,
  ModalBackground,
  ModalCard,
  HeaderContainer,
} from "./styles";

interface HeadingProps {
  goToTelephone(): void;
  profile: any;
}

const ProfileLeft = ({ goToTelephone, profile }: HeadingProps) => {
  let [expandState, setExpandState] = useState(false);
  let [isSub, setIsSub] = useState(false);
  let [socials, setSocials] = useState<any>();
  let [socialsIcon, setSocialsIcon] = useState<any>();
  let [contact, setContact] = useState<any>();
    const [details, setDetails] = useState({isSet:false});

  const toggleClear = () => {
    setExpandState(!expandState);
  };
  const origin = window.location.origin;
  const copyLink = () => {
    navigator.clipboard.writeText(origin + "/" + profile.slug);
    toast.success("Link copied to clipboard");
  };

  const handleCopyLinkClick = () => {
    copyLink();
  };

  const getSocials = async () => {
    axios
      .get(`${API_URL}/socials/${profile.businessUuid}`)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setSocials(response.data.data.socials);
        }
      })
      .catch((error) => {
        if (
          error?.response?.status === 400 ||
          error?.response?.status === 401
        ) {
          return;
        }
      });
  };
  const getContact = async () => {
    axios
      .get(`${API_URL}/contact/${profile.businessUuid}`)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setContact(response.data.data.contact);
        }
      })
      .catch((error) => {
        if (
          error?.response?.status === 400 ||
          error?.response?.status === 401
        ) {
          return;
        }
      });
  };

    const getDankDetails = () => {
      axios
        .get(`${API_URL}/bank_account_details/${profile.businessUuid}`)
        .then((response: any) => {
          if (response.status === 200) {
            setDetails({
              isSet:response.data.data.accountDetails.isSet,
            });

            return;
          }
        })
        .catch((error) => {
          // toast.error("Failed to fetch profile");
          return;
        });
    };
   
      
      useEffect(
        () => {
      getDankDetails();
    getSocials();
    getContact();
    },
    // eslint-disable-next-line
    []
  );
  useEffect(
    () => {
      setSocialsIcon([
        {
          name: "Snapchat",
          available: socials?.snapchat ? true : false,
          img: Snapchat,
          url: socials?.snapchat,
        },
        {
          name: "Instagram",
          available: socials?.instagram ? true : false,
          img: Instagram,
          url: socials?.instagram,
        },
        {
          name: "Facebook",
          available: socials?.facebook ? true : false,
          img: Facebook,
          url: socials?.facebook,
        },
        {
          name: "WhatsApp",
          available: contact?.whatsapp ? true : false,
          img: WhatsApp,
          url: contact?.whatsapp,
        },
        {
          name: "Telegram",
          available: socials?.telegram ? true : false,
          img: Telegram,
          url: socials?.telegram,
        },
        {
          name: "Twitter",
          available: socials?.twitter ? true : false,
          img: TwitterX,
          url: socials?.twitter,
        },
        {
          name: "LinkedIn",
          available: socials?.linkedin ? true : false,
          img: LinkedIn,
          url: socials?.linkedin,
        },
        {
          name: "YouTube",
          available: socials?.youtube ? true : false,
          img: YouTube,
          url: socials?.youtube,
        },
        {
          name: "TikTok",
          available: socials?.tiktok ? true : false,
          img: TikTok,
          url: socials?.tiktok,
        },
        {
          name: "Discord",
          available: socials?.discord ? true : false,
          img: Discord,
          url: socials?.discord,
        },
        {
          name: "WeChat",
          available: socials?.wechat ? true : false,
          img: WeChat,
          url: socials?.wechat,
        },
        {
          name: "Pinterest",
          available: socials?.pinterest ? true : false,
          img: Pinterest,
          url: socials?.pinterest,
        },
        {
          name: "Twitch",
          available: socials?.twitch ? true : false,
          img: Twitch,
          url: socials?.twitch,
        },
        {
          name: "reddit",
          available: socials?.reddit ? true : false,
          img: Reddit,
          url: socials?.reddit,
        },
        {
          name: "website",
          available: socials?.website ? true : false,
          img: Website,
          url: socials?.website,
        },
      ]);
    },
    // eslint-disable-next-line
    [socials]
  );

  return (
    <Container>
      <Header>{ profile.name }</Header>
      {
        profile.description?

      <Description>
        <ExpandIcon onClick={() => setExpandState(true)}>
          <img src={expand} alt="" />
        </ExpandIcon>
        <p>{profile.description}</p>
      </Description>
        :null
      }
      {socials ? (
        <Social>
          {socialsIcon?.map((item: any, index: any) => {
            return item.available ? (
              <a
                key={index}
                href={item?.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={item.img} alt="" />
              </a>
            ) : null;
          })}
        </Social>
      ) : null}

      <Finance>
        <Col1>
          <Subscribe
            onClick={() => {
              setIsSub(true);
            }}
          >
            <img src={Bell} alt="" />
            <p>Subscribe</p>
          </Subscribe>
          <Share onClick={handleCopyLinkClick}>
            <img src={screenshare} alt="" />
            Share
          </Share>
        </Col1>
        {
          details.isSet?
        <Pay>
          <img src={Coin} alt="" />
          <Link
            to={{ pathname: "/payment" }}
            state={profile}
            className="w-[100%]  "
            >
            Pay / Support
          </Link>
        </Pay>
            :null
          }
        { contact?.email ? (
          <a
              href={`mailto:${contact?.email}`}
              target="_blank"
              rel="noopener noreferrer"
            >
          <Email>
            <img src={Letter} alt="" />
         
              Send Email
          </Email>
            </a>
        ) : null}
        {contact?.whatsappUrl ? (
            <a
              href={contact?.whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
          <Hello>
            <img src={WhatsApp} alt="" />
              Send a Message
          </Hello>
            </a>
        ) : null}
      </Finance>
      {expandState ? (
        <ModalBackground onClick={toggleClear}>
          <ModalCard onClick={(event) => event.stopPropagation()}>
            <HeaderContainer>
              <div>
                <img src={profile.image} alt="" />
              </div>
              <h1>{profile.name}</h1>
            </HeaderContainer>
            <p>{profile.description}</p>
          </ModalCard>
        </ModalBackground>
      ) : null}
      {isSub ? (
        <SubscribeModal
          businessUuid={profile.businessUuid}
          setIsSub={setIsSub}
        />
      ) : null}
    </Container>
  );
};

export default ProfileLeft;
